import { useLocation, useNavigate } from "react-router-dom";
import { TiArrowBack } from "react-icons/ti";
import { TbBrandWhatsappFilled } from "react-icons/tb";
import { RiMailSendFill } from "react-icons/ri";

const JobPreview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const job = location.state?.job;

  if (!job) {
    return <p className="text-center mt-5">No job data found</p>;
  }

  const handleApprove = () => {
  const allJobs = JSON.parse(localStorage.getItem("AllPostedJobs")) || [];

  const updated = allJobs.map((j) =>
    j.id === job.id ? { ...j, admin: "Approved" } : j
  );

  localStorage.setItem("AllPostedJobs", JSON.stringify(updated));

  alert("Job Approved Successfully");
  navigate(-1); // go back after approve
};

const handleReject = () => {
  const allJobs = JSON.parse(localStorage.getItem("AllPostedJobs")) || [];

  const updated = allJobs.map((j) =>
    j.id === job.id ? { ...j, admin: "Rejected" } : j
  );

  localStorage.setItem("AllPostedJobs", JSON.stringify(updated));

  alert("Job Rejected Successfully");
  navigate(-1); // go back after reject
};

  return (
    <section className="adminjobpost">
      <div className="container">

        {/* ===== TITLE ===== */}
        <h3
          className="training-title mt-2 fw-bold"
          style={{ color: "#8D0000" }}
        >
          Employee Job Posts
        </h3>

        {/* ===== TOP ACTION BAR (MISSED PART – NOW ADDED) ===== */}
        <div className="d-flex justify-content-between mb-3">

          {/* LEFT */}
          <div>
            {/* <button className="admin-delt">Delete</button> */}
          </div>

          {/* CENTER */}
          <div className="d-flex gap-3 align-items-center">
            <div className="form-check">
              <input type="checkbox" className="form-check-input job-checkbox" />
              <label className="form-check-label ms-1 admin-select">
                <RiMailSendFill style={{ color: "#ffc107", fontSize: "20px" }} /> Email
              </label>
            </div>

            <div className="form-check">
              <input type="checkbox" className="form-check-input job-checkbox" />
              <label className="form-check-label ms-1 admin-select">
                <TbBrandWhatsappFilled style={{ color: "green", fontSize: "20px" }} /> Whatsapp
              </label>
            </div>

            <button className="admin-serch">Send</button>
          </div>

          {/* RIGHT */}
          <div className="d-flex gap-3">
            <button className="admin-app" onClick={handleApprove} >Approve</button>
            <button className="admin-rej" onClick={handleReject}>Reject</button>
          </div>

        </div>

        {/* ===== JOB PREVIEW CARD (READ ONLY) ===== */}
        <div className="hrjobpost-wrapper">
          <div className="hrjobpost-card">

            <button className="jobback" onClick={() => navigate(-1)}>
              <TiArrowBack /> Back
            </button>

            <h2 className="hrjobpost-title">JOB PREVIEW</h2>

            <div className="hrjobpost-grid">

              <div className="hrjobpost-field">
                <label>Job Title</label>
                <input value={job.jobTitle} readOnly />
              </div>

              <div className="hrjobpost-field">
                <label>Company Name</label>
                <input value={job.companyname} readOnly />
              </div>

              <div className="hrjobpost-field">
                <label>Department</label>
                <input value={job.department} readOnly />
              </div>

              <div className="hrjobpost-field">
                <label>Work Mode</label>
                <input value={job.workMode} readOnly />
              </div>

              <div className="hrjobpost-field hrjobpost-full">
                <label>Roles & Responsibilities</label>
                <textarea value={job.roles} readOnly />
              </div>

              <div className="hrjobpost-field">
                <label>Experience</label>
                <input
                  value={`${job.experienceMin} - ${job.experienceMax} years`}
                  readOnly
                />
              </div>

              <div className="hrjobpost-field hrjobpost-full">
                <label>Required Skills</label>
                <textarea value={job.skills?.join(", ")} readOnly />
              </div>

              <div className="hrjobpost-field">
                <label>Qualification</label>
                <input value={job.qualification} readOnly />
              </div>

              <div className="hrjobpost-field">
                <label>Salary (LPA)</label>
                <input
                  value={`${job.salaryMin} - ${job.salaryMax}`}
                  readOnly
                />
              </div>
              <div className="hrjobpost-field hrjobpost-full">
                <label>Perks & Benefits</label>
                <textarea
                  className="form-control bg-white"
                  rows="2"
                  value={job.perks?.join(", ") || ""}
                  readOnly
                />
              </div>


              <div className="hrjobpost-field">
                <label>Job Location</label>
                <input value={job.jobLocation} readOnly />
              </div>

              <div className="hrjobpost-field">
                <label>Job Locality</label>
                <input value={job.jobLocality} readOnly />
              </div>

              <div className="hrjobpost-field">
                <label>Openings</label>
                <input value={job.openings} readOnly />
              </div>

              <div className="hrjobpost-field">
                <label>Deadline</label>
                <input value={job.deadline} readOnly />
              </div>

              <div className="hrjobpost-field">
                <label>Admin Status</label>
                <input value={job.admin} readOnly />
              </div>


                <div className="hrjobpost-field">
                <label>Whatsapp Number</label>
                <input value={job.whtspnumber} readOnly />
              </div>



              {job.attachment && (
                <div className="hrjobpost-field hrjobpost-full">
                  <label>Attachment</label>
                  {job.attachment.startsWith("data:image") ? (
                    <img
                      src={job.attachment}
                      alt="Attachment"
                      style={{ maxWidth: "300px" }}
                    />
                  ) : (
                    <a href={job.attachment} target="_blank" rel="noreferrer">
                      View Document
                    </a>
                  )}
                </div>
              )}

            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default JobPreview;
